import { Map } from 'maplibre-gl';
import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('map-viewer')
export class MapViewer extends LitElement {

    // Props

    @property({ type: Number })
    lat: number = 0;

    @property({ type: Number })
    lng: number = 0;

    @property({ type: Number })
    zoom: number = 14;

    @property({ type: Number, attribute: 'min-zoom' })
    minZoom: number = 12;

    @property({ type: Number, attribute: 'max-zoom' })
    maxZoom: number = 16;

    @state()
    _map: Map | null = null;

    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('MapViewer');
    }

    firstUpdated() {
        const marker: HTMLImageElement = document.createElement('img');
        marker.src = '/assets/img/map/map_marker.png';
        this._map = new Map({
            container: this,
            style: '/assets/data/map/map_style.json',
            center: [this.lat, this.lng],
            zoom: this.zoom,
            minZoom: this.minZoom,
            maxZoom: this.maxZoom,
        });
        this._map.on('load', () => {
            this._map.addSource('point', {
                type: 'geojson',
                data: {
                    "type": "FeatureCollection",
                    "features": [{
                        "type": "Feature",
                        "properties": {},
                        "geometry": {
                            "type": "Point",
                            "coordinates": [this.lat, this.lng],
                        }
                    }]
                }
            });
            this._map.addImage('marker', marker, { sdf: true })
            this._map.addLayer({
                id: 'point_marker',
                type: 'symbol',
                source: 'point',
                layout: {
                    'icon-image': 'marker',
                    'icon-size': 0.5
                },
                paint: {
                    'icon-color': '#DFCF54',
                    'icon-opacity': 1
                }
            });
        });
    }

    render() {
        return html``;
    }

    createRenderRoot() { 
        return this;
    }

}